import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WhatsAppChatButtonProps {
  phoneNumber: string;
  recipientName: string;
  messageContext?: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "default" | "outline" | "ghost";
}

export const WhatsAppChatButton = ({
  phoneNumber,
  recipientName,
  messageContext = "supervision",
  size = "default",
  variant = "default",
}: WhatsAppChatButtonProps) => {
  const getContextMessage = () => {
    const appName = "Golf Progress Calculator";
    switch (messageContext) {
      case "supervision":
        return `Bonjour ${recipientName}, je vous contacte via ${appName} concernant votre supervision...`;
      case "question":
        return `Bonjour ${recipientName}, j'ai une question concernant l'entraînement...`;
      case "appointment":
        return `Bonjour ${recipientName}, je souhaite planifier un rendez-vous...`;
      default:
        return `Bonjour ${recipientName}`;
    }
  };

  const handleClick = () => {
    // Nettoyer le numéro de téléphone
    const cleanPhone = phoneNumber.replace(/\s+/g, "").replace(/[^0-9+]/g, "");
    const message = encodeURIComponent(getContextMessage());
    const whatsappUrl = `https://wa.me/${cleanPhone}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <Button
      onClick={handleClick}
      size={size}
      variant={variant}
      className="bg-[#25D366] hover:bg-[#20BA5A] text-white"
    >
      <MessageCircle className="h-4 w-4 mr-2" />
      WhatsApp
    </Button>
  );
};
